import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { EtablissementRoutingModule } from './etablissement-routing.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {MatLabel} from '@angular/material/form-field';
import { AccueilEtablissementComponent } from './accueil-etablissement/accueil-etablissement.component';
import { SharedModule } from '../../shared/shared.module';
import { CandidaturesComponent } from './candidatures/candidatures.component';
import { MissionsComponent } from './missions/missions.component';
import { PlanningComponent } from './planning/planning.component';
import { MonEtablissementComponent } from './mon-etablissement/mon-etablissement.component';
import { MonEtablissementGeneralComponent } from './mon-etablissement/components/mon-etablissement-general/mon-etablissement-general.component';
import { MonEtablissementDetailDialogComponent } from './mon-etablissement/components/mon-etablissement-detail-dialog/mon-etablissement-detail-dialog.component';
import { HistoriqueComponentComponent } from './missions/historique-component/historique-component.component';
import { EncourComponentComponent } from './missions/encour-component/encour-component.component';
import { MissionDetailsComponent } from './missions/encour-component/mission-details/mission-details.component';
import { SitesAdressesComponent } from './mon-etablissement/components/sites-adresses/sites-adresses.component';
import { MissionCandidaturesComponent } from './missions/encour-component/mission-candidatures/mission-candidatures.component';
import { PersonnelComponent } from './mon-etablissement/components/personnel/personnel.component';
import { AddSiteComponent } from './mon-etablissement/components/sites-adresses/components/add-site/add-site.component';
import { SiteAdresseDetailComponent } from './mon-etablissement/components/sites-adresses/components/site-adresse-detail/site-adresse-detail.component';
import { DetailsComponent } from './candidatures/details/details.component';
import { AncienneCollabComponent } from './candidatures/ancienne-collab/ancienne-collab.component';
import { HistoriqueDetailsComponent } from './missions/historique-component/historique-details/historique-details.component';
import { CandidatureStatusComponent } from './candidatures/table-components/candidature-status/candidature-status.component';
import { CandidatureMissionComponent } from './candidatures/table-components/candidature-mission/candidature-mission.component';
import {AddContactComponent} from "./mon-etablissement/components/personnel/add-contact/add-contact.component";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import { ServicesAffectationComponent } from './mon-etablissement/components/services-affectation/services-affectation.component';
import { AddServicesAffectationComponent } from './mon-etablissement/components/services-affectation/components/add-services-affectation/add-services-affectation.component';
import { MissionValidationComponent } from './missions/mission-validation/mission-validation.component';
import { MissionsRejectedComponent } from './missions/missions-rejected/missions-rejected.component';
import { PlanningMissionDetailsComponent } from './planning/mission-details/mission-details.component';
import {AddMissionComponent} from "./missions/add-mission/add-mission.component";
import {CandidatProfilComponent} from "./missions/historique-component/condidat-profil/condidat-profil.component";
import { TableEnCourActionComponent } from './missions/encour-component/components/table-en-cour-action/table-en-cour-action.component';
import { ProfileComponent } from './profile/profile.component';
import { CandidaturesMissionComponent } from './missions/encour-component/components/candidatures-mission/candidatures-mission.component';
import { UserCandidatureComponent } from './candidatures/user-candidature/user-candidature.component';
import { AddressNameComponent } from './mon-etablissement/components/sites-adresses/components/address-name/address-name.component';
import {MatRadioGroup, MatRadioModule} from "@angular/material/radio";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { ReferenceTitleComponent } from './missions/reference-title/reference-title.component';


@NgModule({
    declarations: [
        AccueilEtablissementComponent,
        CandidaturesComponent,
        MissionsComponent,
        PlanningComponent,
        MonEtablissementComponent,
        AddMissionComponent,
        MonEtablissementGeneralComponent,
        MonEtablissementDetailDialogComponent,
        HistoriqueComponentComponent,
        EncourComponentComponent,
        MissionDetailsComponent,
        SitesAdressesComponent,
        PersonnelComponent,
        AddSiteComponent,
        SiteAdresseDetailComponent,
        MissionCandidaturesComponent,
        DetailsComponent,
        AncienneCollabComponent,
        HistoriqueDetailsComponent,
        CandidatProfilComponent,
        CandidatureStatusComponent,
        CandidatureMissionComponent,
        AddContactComponent,
        ServicesAffectationComponent,
        AddServicesAffectationComponent,
        MissionValidationComponent,
        MissionsRejectedComponent,
        PlanningMissionDetailsComponent,
        TableEnCourActionComponent,
        ProfileComponent,
        CandidaturesMissionComponent,
        UserCandidatureComponent,
        AddressNameComponent,
        ReferenceTitleComponent,
    ],
    imports: [
        CommonModule,
        EtablissementRoutingModule,
        SharedModule,
        AngularSvgIconModule.forRoot(),
        MatLabel,
        NgxIntlTelInputModule,
        NgOptimizedImage,
        MatRadioModule,
        NgxSkeletonLoaderModule,
        TooltipModule,
        // MatRadioGroup
    ],
  exports: [
    MissionCandidaturesComponent,
    MonEtablissementGeneralComponent,
    SitesAdressesComponent,
    PersonnelComponent,
    ServicesAffectationComponent
  ]
})
export class EtablissementModule { }
